var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationOn1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_932_3063",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 31,
    height: 30
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 30,
    height: 30,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_932_3063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 26.6562C15.2083 26.6562 14.9167 26.6042 14.625 26.5C14.3333 26.3958 14.0729 26.2396 13.8438 26.0312C12.4896 24.7812 11.2917 23.5625 10.25 22.375C9.20833 21.1875 8.33854 20.0365 7.64062 18.9219C6.94271 17.8073 6.41146 16.7344 6.04688 15.7031C5.68229 14.6719 5.5 13.6875 5.5 12.75C5.5 9.625 6.50521 7.13542 8.51563 5.28125C10.526 3.42708 12.8542 2.5 15.5 2.5C18.1458 2.5 20.474 3.42708 22.4844 5.28125C24.4948 7.13542 25.5 9.625 25.5 12.75C25.5 13.6875 25.3177 14.6719 24.9531 15.7031C24.5885 16.7344 24.0573 17.8073 23.3594 18.9219C22.6615 20.0365 21.7917 21.1875 20.75 22.375C19.7083 23.5625 18.5104 24.7812 17.1562 26.0312C16.9271 26.2396 16.6667 26.3958 16.375 26.5C16.0833 26.6042 15.7917 26.6562 15.5 26.6562ZM15.5 15C16.1875 15 16.776 14.7552 17.2656 14.2656C17.7552 13.776 18 13.1875 18 12.5C18 11.8125 17.7552 11.224 17.2656 10.7344C16.776 10.2448 16.1875 10 15.5 10C14.8125 10 14.224 10.2448 13.7344 10.7344C13.2448 11.224 13 11.8125 13 12.5C13 13.1875 13.2448 13.776 13.7344 14.2656C14.224 14.7552 14.8125 15 15.5 15Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOn1);
export default __webpack_public_path__ + "static/media/location_on1.1cef269e738ce9557551deeecc237487.svg";
export { ForwardRef as ReactComponent };